import { useCart } from '../context/CartContext';
import { soundEffects } from '../utils/soundEffects';
import { hapticFeedback } from '../utils/hapticFeedback';
import ButtonAnimations from '../utils/buttonAnimations';

export const useEnhancedAddToCart = () => {
  const { addToCart } = useCart();

  const handleEnhancedAddToCart = (product, selectedRAM = null, selectedStorage = null, buttonElement = null) => {
    if (product.availability && product.availability !== 'Available') {
      // Error feedback
      hapticFeedback.error();
      if (buttonElement) {
        ButtonAnimations.shakeElement(buttonElement);
      }
      return false;
    }

    // Play sound effect
    soundEffects.playAddToCartSound();
    
    // Haptic feedback
    hapticFeedback.addToCart();
    
    // Button animation
    if (buttonElement) {
      ButtonAnimations.animateAddToCart(buttonElement, {
        successColor: 'linear-gradient(135deg, #10b981, #059669)'
      });
    }

    // Add to cart (automatically opens global popup)
    addToCart(product, selectedRAM, selectedStorage);
    
    // Set added product for popup was removed as we use global sidebar
    
    // Show cart popup after a short delay is handled by CartContext
    setTimeout(() => {
      soundEffects.playSuccessSound();
    }, 300);

    return true;
  };

  return {
    handleEnhancedAddToCart,
  };
};